/*
 * @Autor: fengqi
 * @Date: 2019-10-11 15:00:57
 * @LastEditors: fengqi
 * @LastEditTime: 2019-10-14 15:17:36
 */
/* eslint-disable */
import axios from "axios";
import wx from 'weixin-js-sdk'

async function getShareInfo () {
  var urlData = window.$utils.getDatas()
  return window.$http('scanCard', {
    qrCode: urlData.qrCode || ''
  })
}

async function getWXSign() {
  let res = await getShareInfo()
  let shareInfo = res.info
  var wxPath = window.location.href.indexOf("https") > -1 ? process.env.VUE_APP_WXPATHS : process.env.VUE_APP_WXPATH
  return new Promise((resolve, reject) => {
    const jsApiList = [
      "updateAppMessageShareData",
    ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
    axios
      .get(wxPath, {
        url: window.encodeURIComponent(window.location.href.split("#")[0])
      })
      .then(function (res) {
        if (res.data.success) {
          const data = res.data.data;
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: data.appid, // 必填，企业号的唯一标识，此处填写企业号corpid
            timestamp: data.timestamp, // 必填，生成签名的时间戳
            nonceStr: data.noncestr, // 必填，生成签名的随机串
            signature: data.sign, // 必填，签名，见附录1
            jsApiList: jsApiList
          });
          wx.ready(function (res) {
            wx.updateAppMessageShareData({
              title: shareInfo.shareTitle, // 分享标题
              link: window.location.href,
              desc: '', // 分享描述
              imgUrl: shareInfo.shareImg, // 分享图标
              // type: '', // 分享类型,music、video或link，不填默认为link
              // dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
              success: function () {
                // 用户确认分享后执行的回调函数
              },
              cancel: function () {
                // 用户取消分享后执行的回调函数
              }
            })
            resolve(wx)
          })
          wx.error(function (res) {
            reject('wx', res)
          })
        }
      })
      .catch(function (error) {
        reject(error)
      })
  })
}
export default getWXSign
